import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";

const o = {
  Classification: "",
  Code: "",
  Definition: "",
  Id: "",
  Notes: "",
  Specialization: "",
  Type: "",
  SpecialtyTypeVal: "",
  SpecialtyclassificationVal: "",
  SpecialtySpecializationVal: "",
};

const SpecialtyDropdown = ({ SpecialFormFields, codes, editObj }) => {
  const { userRole, userToken, customerObj, sharedObject, SetSharedObject } =
    useUserStore((state) => ({
      userRole: state.userRole,
      userToken: state.userToken,
      customerObj: state.customerObj,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    }));
  const navigate = useNavigate();
  const [processing, SetProcessing] = useState(false);
  const [answers, setAnswers] = useState(o);
  const [obj2, setObj2] = useState([]);
  const [obj3, setObj3] = useState([]);
  const [tempObj, setTempObj] = useState(false);
  const [SpecialtyTypeVal, setSpecialtyTypeVal] = useState("");
  const [SpecialtyclassificationVal, setSpecialtyclassificationVal] =
    useState("");
  const [SpecialtySpecializationVal, setSpecialtySpecializationVal] =
    useState("");
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  useEffect(() => {
    if (sharedObject.specialties) {
      setVals(editObj);
    }
    SpecialFormFields(answers);
  }, [editObj]);
  useEffect(() => {
    if (tempObj) {
      setSpecialtyTypeVal(tempObj.type);
      setSpecialtyclassificationVal(tempObj.classification);
      setSpecialtySpecializationVal(tempObj.code);
    }
  }, [tempObj]);
  const setVals = async (editObj) => {
    setObj2([]);
    setObj3([]);
    setSpecialtyTypeVal("");
    setSpecialtyclassificationVal("");
    setSpecialtySpecializationVal("");
    let val = editObj ? editObj[0] : null;
    if (val?.Type) {
      await getTypes("SpecialtyType", val?.Type);
    }
    if (val?.Classification && val?.Type) {
      await getTypes("Specialtyclassification", val?.Classification, val.Type);
    }
    if (val?.Code) {
      await getTypes("SpecialtySpecialization", val?.Code);
    }
  };

  const getTypes = async (type, vl, tp) => {
    let val = encodeURIComponent(vl);
    const o = {
      Classification: "",
      Code: "",
      Definition: "",
      Id: 0,
      Notes: "",
      Specialization: "",
      Type: "",
    };
    let secCall = tp ? tp : SpecialtyTypeVal;
    SetProcessing(true);
    let call = "";
    if (type === "SpecialtyType") {
      call = "/organization/Level2TexCodes?type=" + val;
      setObj2([]);
      setObj3([]);
      setSpecialtyTypeVal(vl);
      await SpecialFormFields({ ...o, [type]: vl });
      await SetSharedObject("specialties", { ...o, Type: vl });
    } else if (type === "SpecialtySpecialization") {
      if (val === "") {
        await SetSharedObject("specialties", {
          ...sharedObject.specialties,
          Code: "",
          Id: 0,
          Notes: "",
          Definition: "",
          Specialization: "",
        });
      }
      call = "/organization/getSpecialty?code=" + val;
      setSpecialtySpecializationVal(vl);
    } else {
      setObj3([]);
      call =
        "/organization/Level3TexCodes?type=" +
        encodeURIComponent(secCall) +
        "&classification=" +
        val;
      //setSpecialtyTypeVal(secCall);
      setSpecialtyclassificationVal(vl);
      await SpecialFormFields({ Type: secCall, Classification: vl });
      await SetSharedObject("specialties", {
        Type: secCall,
        Classification: vl,
      });
    }
    if (val !== "") {
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        let dt = res.data.data;
        if (type === "SpecialtyType") {
          setObj2(dt);
        } else if (type === "SpecialtySpecialization") {
          let codesObj = {
            ...answers,
            Type: dt?.type,
            Code: dt?.code,
            Classification: dt?.classification,
            Specialization: dt?.specialization,
            Id: dt?.id,
            Notes: dt?.notes,
            Definition: dt?.definition,
          };
          await SetSharedObject("specialties", codesObj);
          await SpecialFormFields(codesObj);
          setTempObj(dt);
        } else {
          setObj3(dt);
        }
      } else if (res.status === "SERVERERROR") {
        SetProcessing(false);
      }
    }
    SetProcessing(false);
  };

  return (
    <div className="SpecialtyDropdown">
      <div className="field-wrapper">
        <label for="SpecialtyType">Type</label>
        <select
          className="form-control"
          name="SpecialtyType"
          value={SpecialtyTypeVal}
          onChange={(el) => getTypes("SpecialtyType", el.target.value)}
        >
          <option value="">Select</option>
          {sharedObject?.codes?.map((el) => (
            <option key={el.value} value={el.value}>
              {el.text}
            </option>
          ))}
        </select>
      </div>
      <div className="field-wrapper">
        <label for="Specialtyclassification">Classification</label>
        <select
          className="form-control"
          name="SpecialtyClassification"
          value={SpecialtyclassificationVal}
          onChange={(el) =>
            getTypes("SpecialtyClassification", el.target.value)
          }
        >
          <option value="">Select</option>
          {obj2?.map((el) => (
            <option key={el.text} value={el.text}>
              {el.text}
            </option>
          ))}
        </select>
      </div>
      <div className="field-wrapper">
        <label for="SpecialtySpecialization">Specialization</label>
        <select
          className="form-control"
          name="SpecialtySpecialization"
          value={SpecialtySpecializationVal}
          onChange={(el) => {
            getTypes("SpecialtySpecialization", el.target.value);
          }}
        >
          <option value="">Select</option>
          {obj3?.map((el) => (
            <option key={el.value} value={el.value}>
              {el.text}
            </option>
          ))}
        </select>
      </div>
      {processing ? <div className="loading"></div> : null}
    </div>
  );
};

export default SpecialtyDropdown;
